import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import Bracket from './pages/Bracket';
import Leaderboard from './pages/Leaderboard';
import Admin from './pages/Admin';
import ViewBracket from './pages/ViewBracket';
import Stadiums from './pages/Stadiums';
import FunFacts from './pages/FunFacts';
import DailySim from './pages/DailySim';

export const AuthContext = React.createContext(null);

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  if (!user?.is_admin) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('user') || 'null'));

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <Router>
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
            <Route path="/register" element={user ? <Navigate to="/" replace /> : <Register />} />
            <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
            <Route path="/league/:leagueId/bracket" element={<PrivateRoute><Bracket /></PrivateRoute>} />
            <Route path="/league/:leagueId/leaderboard" element={<PrivateRoute><Leaderboard /></PrivateRoute>} />
            <Route path="/league/:leagueId/bracket/:userId" element={<PrivateRoute><ViewBracket /></PrivateRoute>} />
            <Route path="/stadiums" element={<Stadiums />} />
            <Route path="/fun-facts" element={<FunFacts />} />
            <Route path="/daily-sim" element={<DailySim />} />
            <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </Router>
    </AuthContext.Provider>
  );
}
